/**
 * GA4 via gtag. Uses REACT_APP_GA_MEASUREMENT_ID (e.g. G-XXXXXXXXXX).
 * Missing or blank values disable analytics without affecting the app.
 */

let gaConfigured = false;

export function getGaMeasurementId() {
  const raw = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (typeof raw !== "string") return null;
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function initializeGoogleAnalytics() {
  const measurementId = getGaMeasurementId();
  if (!measurementId || gaConfigured) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
    measurementId
  )}`;
  script.onerror = () => {};
  document.head.appendChild(script);

  gaConfigured = true;
}

export function trackGaPageView(
  path = `${window.location.pathname}${window.location.search}`,
  title = document.title
) {
  if (!getGaMeasurementId() || !gaConfigured || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
  });
}
